import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap'

const passos = { SELECAO: 1, FINANCEIRO: 2, IMPRESSAO: 3 }

export default function Navigation(props) {
  const { wizard, passo, finalizar, onImprimirComFacial, finalizarV2, tipoContrato, procedimentosSelecionados, recusarProcedimentos, handleDecidirDepois, permitirContratoManual = true, primeiraParcelaMaiorQueCinco = false } = props

  const [isLoading, setLoading] = useState(false)
  const [podeAvancar, setPodeAvancar] = useState(false)

  useEffect(() => {
    setPodeAvancar((passo === passos.SELECAO && procedimentosSelecionados.length > 0) || passo === passos.FINANCEIRO)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passo, procedimentosSelecionados])

  const digitalSemPrimeiraParcelaValida = passo === passos.FINANCEIRO && tipoContrato === 'digital' && !primeiraParcelaMaiorQueCinco
  const digitalBotaoDesabilitado = !primeiraParcelaMaiorQueCinco

  const proximoPasso = () => {
    if (passo === passos.FINANCEIRO) return
    wizard.nextStep()
  }

  const handleImprimir = () => {
    if (onImprimirComFacial) onImprimirComFacial()
  }

  const handleAssinaturaDigital = async () => {
    setLoading(true)
    await finalizarV2()
    setLoading(false)
  }

  return (
    wizard && (
      <Row id='wizard-navigation' className='border-top position-fixed rounded-0 py-3 bg-white'>
        <Col>
          {passo !== passos.SELECAO && passo !== passos.IMPRESSAO && (
            <Button onClick={wizard.previousStep} className='border' variant='light'>
              Anterior
            </Button>
          )}
        </Col>
        {/* {!decidirDepois ? ( */}
        <Col className='text-right'>
          {passo === passos.SELECAO && (
            <Button variant='outline-primary' className='mr-2' onClick={handleDecidirDepois}>
              Decidir depois
            </Button>
          )}
          {!podeAvancar && passo === passos.SELECAO && (
            <Button variant='outline-danger' onClick={recusarProcedimentos}>
              Não realizar procedimentos
            </Button>
          )}
          {podeAvancar && passo === passos.SELECAO && (
            <Button onClick={proximoPasso} variant='primary'>
              Pagamento
            </Button>
          )}
          {podeAvancar && passo === passos.FINANCEIRO && tipoContrato === 'manual' && (
            <Button variant='primary' disabled={isLoading || !permitirContratoManual} onClick={handleImprimir}>
              {isLoading ? <Spinner animation='border' size='sm' variant='light' /> : 'Imprimir documentos'}
            </Button>
          )}
          {podeAvancar && passo === passos.FINANCEIRO && tipoContrato === 'digital' && (
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='tooltip-assinatura-digital'>
                  {digitalSemPrimeiraParcelaValida
                    ? 'Informe valor superior a R$ 5,00 na Primeira parcela para gerar o contrato.'
                    : 'Gerar link de assinatura digital'}
                </Tooltip>
              }
            >
              <span className='d-inline-block'>
                <Button
                  variant='primary'
                  disabled={isLoading || digitalBotaoDesabilitado}
                  onClick={handleAssinaturaDigital}
                >
                  {isLoading ? <Spinner animation='border' size='sm' variant='light' /> : 'Assinatura digital'}
                </Button>
              </span>
            </OverlayTrigger>
          )}
        </Col>
        {/* ) : (
          <Col className='text-right'>
            <Button className='mr-2' variant='outline-danger' onClick={handleDecidirDepois}>
              Cancelar
            </Button>
            <Button variant='primary' onClick={finalizar}>
              {!isLoading ? 'Confirmar adiamento' : <Spinner animation='border' size='sm' variant='light' />}
            </Button>
          </Col>
        )} */}
      </Row>
    )
  )
}
